<template>
  <b-modal id="clinic-show-doctor-comissions" ref="modal" title="Comisiones Profesional" hide-footer>
    <div class="row form-group mt3">
      <div class="col-md-6">
        <strong>Profesional</strong> {{ doctor_name }}
      </div>
      <div class="col-md-6">
        <button type="button" class="btn btn-wabident-round float-right" @click="addComission()"><i
            class="fas fa-plus"></i>&nbsp;Añadir</button>
      </div>
    </div>

    <div class="row form-group clinic-show-doctor-comissions__header text-center">
      <div class="col-md-3">
        <strong>UNIDAD</strong>
      </div>
      <div class="col-md-4">
        <strong>PRODUCTO</strong>
      </div>
      <div class="col-md-2">
        <strong>TIPO</strong>
      </div>
      <div class="col-md-2">
        <strong>CANTIDAD</strong>
      </div>
      <div class="col-md-1">
        <strong>ACC.</strong>
      </div>
    </div>

    <div v-if="!comissions.length" class="row form-group">
      <div class="col text-center">
        <div class="py-5">
          <strong>Pulsa el botón "Añadir" para crear una nueva regla de Comisión</strong>
        </div>
      </div>
    </div>

    <draggable class="clinic-show-doctor-comissions__items" v-model="comissions"
      handle=".clinic-show-doctor-comissions__handle">
      <div v-for="comission, index in comissions" :key="comission.id"
        class="row form-group clinic-show-doctor-comissions__item text-center">
        <!-- UNIT -->
        <div class="col-md-3">
          <div class="d-flex">
            <div class="clinic-show-doctor-comissions__handle px-2 py-2" style="margin-top: 5px">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.20023 3.30013C8.20023 4.29431 7.39428 5.10025 6.4001 5.10025C5.40592 5.10025 4.59998 4.29431 4.59998 3.30013C4.59998 2.30594 5.40592 1.5 6.4001 1.5C7.39428 1.5 8.20023 2.30594 8.20023 3.30013ZM8.20023 10.4998C8.20023 11.494 7.39428 12.2999 6.4001 12.2999C5.40592 12.2999 4.59998 11.494 4.59998 10.4998C4.59998 9.50561 5.40592 8.69966 6.4001 8.69966C7.39428 8.69966 8.20023 9.50561 8.20023 10.4998ZM6.4001 19.5C7.39428 19.5 8.20023 18.6941 8.20023 17.6999C8.20023 16.7057 7.39428 15.8997 6.4001 15.8997C5.40592 15.8997 4.59998 16.7057 4.59998 17.6999C4.59998 18.6941 5.40592 19.5 6.4001 19.5ZM15.3999 3.30013C15.3999 4.29431 14.5939 5.10025 13.5998 5.10025C12.6056 5.10025 11.7996 4.29431 11.7996 3.30013C11.7996 2.30594 12.6056 1.5 13.5998 1.5C14.5939 1.5 15.3999 2.30594 15.3999 3.30013ZM13.5998 12.2999C14.5939 12.2999 15.3999 11.494 15.3999 10.4998C15.3999 9.50561 14.5939 8.69966 13.5998 8.69966C12.6056 8.69966 11.7996 9.50561 11.7996 10.4998C11.7996 11.494 12.6056 12.2999 13.5998 12.2999ZM15.3999 17.6999C15.3999 18.6941 14.5939 19.5 13.5998 19.5C12.6056 19.5 11.7996 18.6941 11.7996 17.6999C11.7996 16.7057 12.6056 15.8997 13.5998 15.8997C14.5939 15.8997 15.3999 16.7057 15.3999 17.6999Z"
                  fill="#A6AAB4" />
              </svg>
            </div>
            <div style="flex-grow: 1">
              <v-select class="wabident-selector" :options="product_categories" placeholder="Todas las unidades"
                v-model="comission.product_category_id" :reduce="c => c.value"></v-select>
              <label class="wabident-info">Unidad médica, dejar vacío para todas</label>
            </div>
          </div>
        </div>

        <!-- PRODUCT -->
        <div class="col-md-4">
          <v-select class="wabident-selector" @search="searchProducts" :filterable="false" :options="products"
            placeholder="Todos" v-model="comission.product"></v-select>
          <label class="wabident-info">Tratamiento, dejar vacío para todos</label>
        </div>

        <!-- TYPE -->
        <div class="col-md-2">
          <select v-model="comission.type" name="role" :id="'comission_type_' + comission.id" class="custom-select">
            <option value="percent">Porcentaje</option>
            <option value="fixed">Fijo</option>
          </select>
          <label class="wabident-info" :for="'comission_type_' + comission.id">
            Tipo
          </label>
        </div>

        <!-- AMOUNT -->
        <div class="col-md-2">
          <input v-model="comission.amount" class="form-control" type="number"
            :id="'comission_amount_' + comission.id" />
          <label class="wabident-info" :for="'comission_amount_' + comission.id">
            Cantidad
            <span v-if="comission.type == 'percent'">(%)</span>
            <span v-else>(€)</span>
          </label>
        </div>

        <!-- ACTIONS -->
        <div class="col-md-1 text-center">
          <button type="button" class="btn btn-wabident-round small red" @click="removeComission(index)"><i
              class="fas fa-trash"></i></button>
        </div>
      </div>
    </draggable>

    <div class="form-group row">
      <div class="col text-center d-flex align-items-center justify-content-around">
        <button :disabled="is_loading" type="button" @click="$refs.modal.hide()" class="btn btn-primary btn-wabident">
          Cancelar
        </button>
        <button :disabled="is_loading" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else>Guardar</span>
          <i v-if="is_loading" class="fas fa-spin fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  props: ['user', 'doctor'],
  data() {
    return {
      comissions: [],
      products: [],
      is_loading: false,
    }
  },
  computed: {
    product_categories() {
      if (!this.clinic) {
        return [];
      }

      return this.clinic.product_categories.map((cat) => {
        return {
          label: cat.name,
          value: cat.id,
        }
      });
    },
    doctor_name() {
      return this.user ? this.user.name : '';
    },
    ...mapGetters(['clinic', 'errorwindow']),
  },
  methods: {
    show() {
      this.loadComissions();
      this.$refs.modal.show();
    },
    loadComissions() {
      if (this.is_loading) {
        return;
      }
      this.is_loading = true;
      axios
        .get(`/clinic/${this.clinic.id}/doctor/${this.doctor.id}/comissions`)
        .then((response) => {
          this.comissions = response.data;
          this.fillProducts();
        }).catch(() => {
          this.errorwindow.show('Error', 'Error leyendo Comisiones del Doctor. Por favor, ponte en contacto con el Administrador', 'Aceptar');
        }).then(() => {
          this.is_loading = false;
        });
    },
    fillProducts() {
      // Dictionary of Product IDs
      let product_ids_dict = {};

      // Build array of Required IDs
      this.comissions.forEach((c) => {
        const product_id = c.product_id;
        if (product_id) {
          product_ids_dict[product_id] = true;
        }
      });

      // Search product IDs
      const product_ids = Object.keys(product_ids_dict);
      if (product_ids.length) {
        axios.get('/product', { params: { product_ids: product_ids } }).
          then((response) => {
            // Product IDs restored
            let products_dict = {};
            // Get products
            response.data.forEach((p) => {
              products_dict[p.id] = {
                label: p.name,
                value: p.id,
              };
            });
            // Finally fill the array
            this.comissions.forEach((c) => {
              c['product'] = products_dict[c.product_id] || null;
            });

            this.$forceUpdate();
          });
      }
    },
    onSubmit() {
      if (this.is_loading) {
        return;
      }
      this.is_loading = true;

      let params = {
        comissions: this.comissions.map((c) => {
          return {
            product_id: c.product.value,
            product_category_id: c.product_category_id,
            amount: c.amount,
            type: c.type
          }
        })
      };

      axios
        .post(`/clinic/${this.clinic.id}/doctor/${this.doctor.id}/comissions`, params)
        .then((response) => {
          this.$refs.modal.hide();
        }).catch(() => {
          this.errorwindow.show('Error', 'Error guardando Comisiones del Doctor. Por favor, ponte en contacto con el Administrador', 'Aceptar');
        }).then(() => {
          this.is_loading = false;
        });
    },
    addComission() {
      this.comissions.push({
        'id': crypto.randomUUID(),
        'product': null,
        'product_category_id': null,
        'type': 'percent',
        'amount': 0,
      });
    },
    removeComission(index) {
      this.comissions.splice(index, 1);
    },
    searchProducts(search, loading) {
      loading(true);
      axios
        .get("/product", {
          params: {
            search: search,
          },
        })
        .then((response) => {
          this.products = response.data.data.map((p) => {
            return {
              label: p.name,
              value: p.id,
            };
          })
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          loading(false);
        });
    },
  }
}
</script>

<style lang="scss">
#clinic-show-doctor-comissions {
  .modal-dialog {
    max-width: 1340px;
  }

  .clinic-show-doctor-comissions__header {
    color: white;
    background-color: var(--theme-color);

    strong {
      display: inline-block;
      padding: 8px;
    }
  }
}
</style>
